import { AppState } from 'Features/App/store';
import { DICTIONARIES_SLICE } from '../dictionariesSlice';

export const stationsFullSelector = (state: AppState) => state[DICTIONARIES_SLICE].stationsFull;
export const stationFullSelector = (stationId: number) => (state: AppState) => {
  return state[DICTIONARIES_SLICE].stationsFull[stationId];
};
export const stationsIdsSelector = (state:AppState): number[] => {
  return Object.keys(state[DICTIONARIES_SLICE].stationsFull).reduce((acc, idString) => {
    acc.push(+idString);
    return acc;
  }, [] as number[]);
};
export const stationsIdsLengthSelector = (state:AppState): number => {
  return stationsIdsSelector(state).length;
};

export const stationSelector = (stationId: number) => (state: AppState) => {
  return state[DICTIONARIES_SLICE].stationsFull[stationId]?.station;
};
export const stationRegionIdSelector = (stationId: number) => (state: AppState) => {
  return state[DICTIONARIES_SLICE].stationsFull[stationId].station.regionId;
};
export const stationDatasourceIdsSelector = (stationId: number) => (state: AppState) => {
  return state[DICTIONARIES_SLICE].stationsFull[stationId].datasourceIds;
};
export const stationDatasourceIdsLengthSelector = (stationId: number) => (state: AppState) => {
  return stationDatasourceIdsSelector(stationId)(state).length;
};


//-------------MONITORING_COPY--------------
export const stationsFullSelectorMonitoring = (state: AppState) => state[DICTIONARIES_SLICE].stationsFull;
export const stationsIdsLengthSelectorMonitoring = (state:AppState): number => {
  return stationsIdsSelector(state).length;
};